import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAppAuth } from "../hooks/use-auth";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@itoresearch/design-system";

export const Route = createFileRoute("/login")({
  component: LoginPage,
});

/**
 * Well-known login path. Some flows (impersonation, invitations, Sign-in URL)
 * start outside the app and redirect here; this page kicks off the hosted
 * AuthKit sign-in and always lands on the home page.
 */
function LoginPage() {
  const { signIn, user } = useAppAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate({ to: "/" });
  }, [user, navigate]);

  return (
    <div className="mx-auto max-w-md space-y-6 py-16">
      <Card>
        <CardHeader>
          <CardTitle>Sign in</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button className="w-full" onClick={() => signIn()}>
            Sign in
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
